module.exports = __webpack_public_path__ + "img/boleta1.6c74c74d.png";